import {AssetStarExchangeOptionPostDataTransferObject} from "../../data-transfer-object/asset/AssetStarExchangeOptionPostDataTransferObject"

/**
 * 스타 교환 옵션 속성 설명
 */
export const AssetStarExchangeOptionPostDataTransferObjectDescription: Record<keyof AssetStarExchangeOptionPostDataTransferObject, string> = {
    starAmount: '지급 스타',
    solarAmount: '차감 솔라'
}
